"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signedExtensions = void 0;
exports.signedExtensions = {
    CheckAppId: {
        extrinsic: {
            appId: "AppId",
        },
        payload: {},
    },
};
